import useUsersByRole from './useUsersByRole';

export default useUsersByRole;
